import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  Dashboard as DashboardIcon,
  School as SchoolIcon,
  Forum as ForumIcon,
  People as PeopleIcon,
  Analytics as AnalyticsIcon,
  Settings as SettingsIcon,
  AutoAwesome as AIIcon,
} from "@mui/icons-material";
import { useAlert } from "@/contexts/AlertContext";
import { WorkshopAdminApi } from "@/api";
import { useNavigate } from "react-router";

export default function Dashboard2() {
  const [loading, setLoading] = useState(false);
  const [summaryData, setSummaryData] = useState(null); // State để lưu trữ dữ liệu tóm tắt
  const alert = useAlert();
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const navigate = useNavigate();

  // Fetch workshops data
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await WorkshopAdminApi.getSummary(userTimeZone);
      console.log(response);
      if (response.code === 200) {
        setSummaryData(response.data); // Cập nhật state với dữ liệu từ API
      } else {
        alert.error(response.message || "Failed to fetch summary data.");
      }
    } catch (error) {
      console.error("Error fetching category:", error);
      alert.error("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(); // Fetch workshops on component mount
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 4 }}>
        Admin Dashboard
      </Typography>

      <Card sx={{ mb: 4, boxShadow: "0 4px 15px rgba(0,0,0,0.06)" }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
            At a Glance
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  sx={{ fontWeight: 700, color: "#4a69bd", mb: 1 }}
                >
                  {summaryData ? summaryData.total_awaiting_proposals : "..."} {/* Hiển thị số lượng đề xuất đang chờ */}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 500, color: "#8395a7" }}
                >
                  Pending Proposals
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  sx={{ fontWeight: 700, color: "#4a69bd", mb: 1 }}
                >
                  0
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 500, color: "#8395a7" }}
                >
                  Reported Items
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  sx={{ fontWeight: 700, color: "#4a69bd", mb: 1 }}
                >
                  {/* Dữ liệu này không có trong response hiện tại, có thể là 0 hoặc placeholder */}
                  {summaryData ? summaryData.new_users_24h : "..."}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 500, color: "#8395a7" }}
                >
                  New Users (24h)
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  sx={{ fontWeight: 700, color: "#4a69bd", mb: 1 }}
                >
                  {summaryData ? summaryData.total_workshops : "..."} {/* Hiển thị tổng số workshop */}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 500, color: "#8395a7" }}
                >
                  Total Workshops
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card sx={{ boxShadow: "0 4px 15px rgba(0,0,0,0.06)" }}>
            <CardContent sx={{ p: 4 }}>
              <Box display={"flex"} justifyContent={"space-between"}>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{ fontWeight: 600, mb: 3 }}
                >
                  Workshop Proposal Queue
                </Typography>
                <Box>
                <Button variant="outlined" size="small" onClick={() => navigate('../workshops')}>
                  View More
                </Button>
                </Box>
              </Box>
              <Box>
                {loading ? (
                  <Typography>Loading proposals...</Typography>
                ) : summaryData && summaryData.awaiting_proposals.length > 0 ? (
                  summaryData.awaiting_proposals.map((proposal) => (
                    <Box
                      key={proposal.id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        py: 2,
                        borderBottom: "1px solid #dfe4ea",
                        "&:last-child": { borderBottom: "none" }, // Loại bỏ border cho item cuối cùng
                      }}
                    >
                      <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                          {proposal.title}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#8395a7" }}>
                          by {proposal.user_fullname}
                        </Typography>
                      </Box>
                      {/* <Button variant="outlined" size="small">
                        Review
                      </Button> */}
                    </Box>
                  ))
                ) : (
                  <Typography>No pending proposals.</Typography>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
        {/* Phần Moderation Queue (đã comment trong code gốc) */}
        {/* <Grid item xs={12} md={6}>
          <Card sx={{ boxShadow: "0 4px 15px rgba(0,0,0,0.06)" }}>
            <CardContent sx={{ p: 4 }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: 600, mb: 3 }}
              >
                Moderation Queue
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", py: 2 }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Comment by John Doe
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#8395a7" }}>
                    Reason: Spam
                  </Typography>
                </Box>
                <Button variant="outlined" size="small">
                  Review
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid> */}
      </Grid>
    </Box>
  );
}